var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"root d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"action position-relative"})])])}]

export { render, staticRenderFns }